export const PROPERTY_OWNER_TYPE_CODE = {
  PERSON: 'Person',
  PLACE: 'Place',
};

// codeRepValues Ids for Category='PropertyOwnerType' are environment-specific and shift whenever
// the reference data is reseeded, so the real Id is resolved by matching the stable Code text
// (propertyOwnerTypes is the getRefValues(Category='PropertyOwnerType') list: {label, value, code})
// instead of a hardcoded Id.
export const getPropertyOwnerTypeIdByCode = (propertyOwnerTypes, code) =>
  (propertyOwnerTypes || []).find((type) => type.code === code)?.value;

export const CUSTODY_TRANSACTION_TYPE = {
  Check_In: 'Check In',
  Check_Out: 'Check Out',
  Record_Transfer: 'Transfer',
};

export const DAYS_IN_EVIDENCE_COLOR = {
  critical: 'var(--evidence-danger)',
  warning: 'var(--evidence-warning-text)',
  normal: 'var(--evidence-success-text)',
};
